import { Tooltip } from '@material-ui/core';
import { useTooltipCommonStyles } from '../styles';
import { formatDate } from '@refund/helpers';

export default function TransactionStatus({ value }) {
  const tooltipClass = useTooltipCommonStyles();
  const style: React.CSSProperties = {
    backgroundColor: value ? "#eb3737" : "#9ACD32",
    width: "100%",
    padding: "2px 8px",
    borderRadius: "6px",
    textAlign: "center",
    color: "white",
    cursor: value ? "pointer" : "default",
  };

  return (
    <div style={style}>
      {value ? (
        <Tooltip classes={{ tooltip: tooltipClass.customTooltip }} title={formatDate(value as any, "pt-BR")} arrow placement="right">
          <div>CANCELADA</div>
        </Tooltip>
      ) : (
        "OK"
      )}
    </div>
  );
}
